<div class="patient-card card" (click)="selectDoctor()">
    <div class="card-body">
        <h5 class="card-title t3"><b>Dr. {{doctor.Name}}</b></h5>
        <div class="card-pills">
            <div class="reference-pill">
                <h6 class="badge badge-pill badge-primary">Reference No: {{doctor.ReferenceId}}</h6>
            </div>
            <div class="practice-pill">
                <h6 class="badge badge-pill badge-secondary">Practice No: {{doctor.PracticeNumber}}</h6>
            </div>
        </div>
    </div>
</div>